import React from 'react';
import { Copyright } from 'components/footer/styled';
import { useLocale } from 'locale';
import styled from '@emotion/styled';


const Wrapper = styled.section`
  border-top: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
  padding-top: 24px;
  color: ${({ theme }) => theme.colors.neutrals.grey4};
`;

const SimpleFooterComponent: React.FC = () => {
  const { t } = useLocale();

  return (
    <Wrapper>
      <Copyright data-auto="copyright">{t('footer.copyright', { year: new Date().getFullYear() })}</Copyright>
    </Wrapper>
  );
};

export const SimpleCopyrightFooter = React.memo(SimpleFooterComponent);
